import styled from 'styled-components';

const FormBody = styled.form`
  display: flex;
  flex-direction: column;
`;

export default FormBody;
